// removed by extract-text-webpack-plugin
module.exports = {"main_block":"CqUjaAvY-v3NsaXXFSkeG","aboutWrap":"_16rKhX7uNKJBAqbIlXyrci","points":"_1Jhb4hgIpfg9vWxrbgQ6Dn","content":"_3ZFY0yjoIkL30Fplt1jIh3","onlyHe":"u9UQcz6uxQMIB2w_MuZ8b"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PrivacyPolicyPage/PrivacyPolicyPage.scss
// module id = 323
// module chunks = 0